module.exports = __webpack_public_path__ + "media/markers/moorings_tur-4ae82c55.svg";